import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee896392"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "search_box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下架")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上架")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableLayout = _resolveComponent("TableLayout")!
  const _component_ContentManageDialog = _resolveComponent("ContentManageDialog")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_TableLayout, null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchHandle.type) = $event)),
                class: "select",
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.list, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchHandle.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchHandle.value) = $event)),
                class: "input",
                placeholder: "请输入内容"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: _ctx.searchHandle.loading,
                onClick: _ctx.searchHandle.search
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ]),
        main: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            height: "100%",
            border: "",
            data: _ctx.tableHandle.mats,
            class: "table_box",
            "row-key": "id",
            onSortChange: _ctx.sortByDesignerId
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "120",
                prop: "id",
                label: "模板ID"
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "400",
                prop: "title",
                label: "模板标题"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                prop: "designer_id",
                label: "设计师ID",
                sortable: "custom"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                prop: "upload_time",
                label: "上传时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(new Date(scope.row.up_load_time), 'yyyy-MM-dd hh:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "模板状态",
                width: "130",
                prop: "status"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(`text-${_ctx.CheckStatusByTypeMap[scope.row.status]}`)
                  }, _toDisplayString(_ctx.CheckStatusByLabelMap[String(scope.row.status)]), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "220",
                label: "模板操作",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.tableHandle.clickDetail(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (scope.row.status === _ctx.CheckStatusMap.up)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "small",
                        type: "danger",
                        onClick: ($event: any) => (_ctx.tableHandle.lowerShelfMat(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  ([_ctx.CheckStatusMap.delete, _ctx.CheckStatusMap.down].includes(scope.row.status))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        type: "danger",
                        onClick: ($event: any) => (_ctx.tableHandle.upperShelfMat(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (scope.row.status !== _ctx.CheckStatusMap.delete)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        size: "small",
                        type: "danger",
                        onClick: ($event: any) => (_ctx.tableHandle.deleteShelfMat(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSortChange"])), [
            [_directive_loading, _ctx.tableHandle.loading]
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            align: "right",
            "current-page": _ctx.paginationHandle.page,
            "page-size": _ctx.paginationHandle.size,
            total: _ctx.paginationHandle.total,
            onSizeChange: _ctx.paginationHandle.handleSizeChange,
            onCurrentChange: _ctx.paginationHandle.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      }),
      (_ctx.contentManageDialogHandle.visible)
        ? (_openBlock(), _createBlock(_component_ContentManageDialog, {
            key: 0,
            id: _ctx.contentManageDialogHandle.id,
            modelValue: _ctx.contentManageDialogHandle.visible,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentManageDialogHandle.visible) = $event)),
            onClickContentManageDialogClose: _ctx.contentManageDialogHandle.clickContentManageDialogClose,
            onClickContentManageDialogModify: _ctx.contentManageDialogHandle.clickContentManageDialogModify
          }, null, 8, ["id", "modelValue", "onClickContentManageDialogClose", "onClickContentManageDialogModify"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}